import { useEffect, useState } from 'react';

// Single breakpoint: phone-width vs everything else. ChatInterface flips
// from desktop's 50/50 horizontal split to a 60/40 vertical stack
// (chat top, output below) when this returns true. No tablet-specific
// behavior — adds complexity without a real case yet.
const QUERY = '(max-width: 640px)';

// record-image-restore: no `matchMedia` (jsdom, an embedding host without it) reads as
// desktop rather than throwing — the hook is now on the record block, which every page
// and tile renders, so its absence must not take the page down.
const canQuery = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export default function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => canQuery() && window.matchMedia(QUERY).matches);
  useEffect(() => {
    if (!canQuery()) return;
    const mql = window.matchMedia(QUERY);
    const handler = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);
  return isMobile;
}
